import React, { createContext, useContext, useState } from 'react';

const SessionExpiredContext = createContext();

export function useSessionExpired() {
  return useContext(SessionExpiredContext);
}

export function SessionExpiredProvider({ children }) {
  const [open, setOpen] = useState(false);

  const showModal = () => setOpen(true);
  const hideModal = () => setOpen(false);

  return (
    <SessionExpiredContext.Provider value={{ open, showModal, hideModal }}>
      {children}
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-xl shadow-xl max-w-sm text-center">
            <h2 className="text-xl font-bold text-red-600 mb-4">Sessão expirada</h2>
            <p className="mb-6 text-gray-700">Seu tempo de sessão expirou. Faça login novamente para continuar.</p>
            <button
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700"
              onClick={() => {
                hideModal();
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
              }}
            >
              Ir para o Login
            </button>
          </div>
        </div>
      )}
    </SessionExpiredContext.Provider>
  );
}